import { render, staticRenderFns } from "./PacsTableCell.vue?vue&type=template&id=1d4d2534"
import script from "./PacsTableCell.vue?vue&type=script&lang=js"
export * from "./PacsTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports